export const bentoNavigationLinks = [
	{
		href: 'https://app.enappsys.com/#gb',
		label: 'EnAppSys',
		openInNewTab: true,
	},
	{
		href: 'https://app.eqenergy.com/',
		label: 'Energy Quantified',
		openInNewTab: true,
	},
	{
		href: '/',
		label: 'Montel Markets',
		openInNewTab: true,
	},
	{
		href: 'https://montelnews.com',
		label: 'Montel News',
		openInNewTab: true,
	},
	{
		href: 'https://app.montelnews.com/news/default.aspx',
		label: 'Montel Online',
		openInNewTab: true,
	},
	{
		href: 'https://syspower5.skm.no',
		label: 'SysPower',
		openInNewTab: true,
	},
];
